/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useRef, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import useOutsideClick from '../../../../../../../../utils/click.utils';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { IShareTaskProps } from './types';

export const ShareTask: FunctionComponent<IShareTaskProps> = ({ task }) => {
  const dispatch = useDispatch();
  const triggerRef = useRef<HTMLAnchorElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskShare');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(storeTaskModalStatus('taskShare'));
    }
  }, [dispatch, open]);
  const link = `https://build.account-able.io/task-preview/${task.id}`;
  const [copy, setCopy] = useState(false);
  const toggleCopy = () => {
    setCopy(true);
    navigator.clipboard.writeText(link);
  };
  const handleClickOutside = () => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    }
  };

  useOutsideClick({
    callback: handleClickOutside,
    refs: [popupRef, triggerRef],
    enabled: open,
  });
  return (
    <div>
      <a className="btn w100 gray-bg darkGray px-1 f-1 ml-0 mb-1 mt-1 check_button" onClick={toggle} ref={triggerRef}>
        <i className="icon f-9 blueGray icon2-cloud-upload mr-1" /> Share
      </a>
      {open && (
        <div style={{ display: 'flex' }} ref={popupRef}>
          <input id={task.id} disabled={true} value={link} style={{ height: '35px' }} />
          <div className={`btn ${copy ? '' : 'gray-bg'} darkGray px-1 f-1 mr-0 check_button`} onClick={toggleCopy}>
            <i className="icon f-9 blueGray icon2-copy mr-1" />
          </div>
        </div>
      )}
    </div>
  );
};
